import prosper from "@/platforms/prosper/config/prosper-config";
import gabon from "@/platforms/gabon/config/gabon-config";

const configs = {
  prosper,
  gabon,
};

const getConfig = () => {
  const env = process.env.VUE_APP_PLATFORM || "prosper";
  return configs[env];
};

export default getConfig();
